import { render, staticRenderFns } from "./AskChatGPT.vue?vue&type=template&id=27408f39&scoped=true"
import script from "./AskChatGPT.vue?vue&type=script&lang=js"
export * from "./AskChatGPT.vue?vue&type=script&lang=js"
import style0 from "./AskChatGPT.vue?vue&type=style&index=0&id=27408f39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27408f39",
  null
  
)

export default component.exports